import React, { useState } from 'react';
import TemplateGallery from './landing-pages/TemplateGallery';
import DeploymentManager from './landing-pages/DeploymentManager';
import SlideDeckTemplates from './landing-pages/SlideDeckTemplates';
import { Layout, Globe, Presentation } from 'lucide-react';

function LandingPages() {
  const [activeTab, setActiveTab] = useState<'templates' | 'deployments' | 'slide-decks'>('templates');

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Landing Pages</h1>
        <p className="mt-2 text-sm text-gray-600">Create and manage your landing pages and presentation templates</p>
      </div>

      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('templates')}
              className={`${
                activeTab === 'templates'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Layout className="h-5 w-5 mr-2" />
              Landing Templates
            </button>
            <button
              onClick={() => setActiveTab('slide-decks')}
              className={`${
                activeTab === 'slide-decks'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Presentation className="h-5 w-5 mr-2" />
              Slide Decks
            </button>
            <button
              onClick={() => setActiveTab('deployments')}
              className={`${
                activeTab === 'deployments'
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Globe className="h-5 w-5 mr-2" />
              Deployments
            </button>
          </nav>
        </div>
      </div>

      {activeTab === 'templates' && <TemplateGallery />}
      {activeTab === 'slide-decks' && <SlideDeckTemplates />}
      {activeTab === 'deployments' && <DeploymentManager />}
    </div>
  );
}

export default LandingPages;